// extracted by mini-css-extract-plugin
export default {"formRow":"PlanShutdownModal_formRow__SMkqz","removeIcon":"PlanShutdownModal_removeIcon__SgDSu"};